import { useConfig } from "@/contexts/cdpConfig";
export const useLoginUrl = () => {
    const { oauthBaseUrl } = useConfig();
    if (typeof window === "undefined")
        return "";
    const pathname = window.location.pathname;
    const search = window.location.search;
    const encodedPath = encodeURIComponent(`${pathname}${search}#contact-modal`);
    return `${oauthBaseUrl}?forceLogin=true&target=portal&path=${encodedPath}&m=classified_detail_login_save_info_account_login`;
};
